import { RepositoryFactory } from '@/http/api/RepositoryFactory'
const UserRepository = RepositoryFactory.get('UserRepository');

import { DefaultStoreActions } from '@/store/utils/requests'
const { get, create } = DefaultStoreActions(UserRepository)

export const STORE_MODULE_NAME = 'user';
export const STORE_MODULE_CONFIG =  {
    namespaced: true,
    state: {
        isVerticalMenuActive: false,
    },
    getters: {},
    mutations: {},
    actions: {
        fetch: get,
        create: create,
    },
}
